const state = {
  working_mode: null,
};

const actions = {

};

const mutations = {

};

export const app = {
  namespaced: true,
  state,
  actions,
  mutations,
};
